import React from 'react';
import Header from '../navbar/Header';
import Container from '../Container';
import Content from '../Content';
import Navbar from '../navbar/Navbar';
import RightSide from './RightSide';
import BarAlertCard from './BarAlertCard';


function Dashboard() {
    return ( 
         <Container>
           <Navbar/>

           <Content>
              <Header/>
             
              <RightSide/>
           </Content>
          

         </Container>
     );
}

export default Dashboard;